import React from 'react';

import BannerWithList, {
  IconType,
  ListGroupContent,
} from '../../../components/BannerWithList';
import CheckupAccordionProductCard from '../../components/CheckupAccordion/CheckupAccordionProductCard';

import styles from './index.module.scss';

type ProductData = {
  type: string;
  description: string;
  link: string;
  tags: string;
  name: string;
  price: string;
  image: string;
  addToCartUrl: string;
};

interface BannerWithListAndProductCardProps {
  listGroups: ListGroupContent[];
  title: string;
  iconType: IconType;
  product: ProductData;
}

const BannerWithListAndProductCard: React.FC<
  BannerWithListAndProductCardProps
> = ({ listGroups, title, iconType, product }) => {
  return (
    <div className={styles.wrapper}>
      <BannerWithList
        className={styles.list}
        title={title}
        iconType={iconType}
        listGroups={listGroups}
      />
      <CheckupAccordionProductCard
        className={styles.product}
        key={product.type}
        description={product.description}
        link={product.link}
        tags={product.tags}
        name={product.name}
        price={product.price}
        image={product.image}
        addToCartUrl={product.addToCartUrl}
        onToggle={undefined}
        variantId={product.type}
        isChecked={false}
      />
    </div>
  );
};

export default BannerWithListAndProductCard;
